<template>
    <div class="card">
       <div class="preview-wrapper">
          <div class="cart background-container">
             <div v-if="shoppingCart && shoppingCart.length">
              <div class="row border-bottom" v-for="product in shoppingCart" :key="product.priceId">
                <div class="row main align-items-center">
                   <div class="col-2" v-if="product.name.includes('session')"><img class="img-fluid" src="../assets/images/workout.png"></div>
                   <div class="col-2" v-if="product.name.includes('coin')"><img class="img-fluid" src="../assets/images/tokens.png"></div>
                   <div class="col-2" v-if="product.name === 'Glove'"><img class="img-fluid" src="../assets/images/glove.png"></div>
                   <div class="col-2" v-if="product.name === 'Knee Sleeve'"><img class="img-fluid" src="../assets/images/knee_sleeve.png"></div>
                   <div class="col-2" v-if="product.name === 'Pants'"><img class="img-fluid" src="../assets/images/knee_sleeve.png"></div>
                   <div class="col-2" v-if="product.name === 'Band'"><img class="img-fluid" src="../assets/images/band.jpg"></div>
                   <div class="col-2" v-if="product.name === 'Neat'"><img class="img-fluid" src="../assets/images/neat.png"></div>
                   <div class="col-3">
                      <div class="row muted-text">{{ product.name }}</div>
                      <div class="row"></div>
                   </div>
                   <div class="col-4">
                      <a class="text" href="#" @click.prevent="decrementQuantity(product)">-</a><a href="#" class="border text">{{ product.quantity }}</a><a class="text" href="#" @click.prevent="incrementQuantity(product)">+</a>
                   </div>
                   <div class="col-3">$ {{ product.price * product.quantity }} <span @click="removeProduct(product)" class="close text">&#10005;</span></div>
                </div>
             </div>
             </div>
             <div v-else>
              <el-empty description="Your cart is empty" />
             </div>
          </div>
       </div>
       <div class="summary">
         <div class="row">
            <div class="col" style="padding-left:0;">Subtotal</div>
            <div class="col text-right">$ {{ Number(total).toFixed(2) }}</div>
         </div>
         <div class="row mt-2 mb-2">
            <div class="col" style="padding-left:0;">PST (7%)</div>
            <div class="col text-right">$ {{ (Number(total) * 0.07).toFixed(2) }}</div>
         </div>
         <div class="row mt-2 mb-2">
            <div class="col" style="padding-left:0;">GST (5%)</div>
            <div class="col text-right">$ {{ (Number(total) * 0.05).toFixed(2) }}</div>
         </div>
         <!-- <div class="row mt-2 mb-2">
            <div class="col" style="padding-left:0;">Shipping</div>
            <div class="col text-right">$ 0</div>
         </div> -->
         <div class="row" style="border-top: 1px solid var(--border-color); padding: 2vh 0;">
            <div class="col">Total</div>
            <div class="col text-right">$ {{ Number(totalWithTaxes).toFixed(2) }}</div>
         </div>
         <button class="btn btn-primary" @click="checkout">CHECKOUT</button>
      </div>
    </div>
    </template>

<script>
import { xray } from '../config/pluginInit'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'

import { useRouter } from 'vue-router'

const body = document.getElementsByTagName('body')

export default {
  setup (props, context) {
    const store = useStore()
    const shoppingCart = computed(() => store.getters['shoppingCart/cartProducts'])
    const total = computed(() => store.getters['shoppingCart/cartTotalPrice'])
    const totalQuantity = computed(() => store.getters['shoppingCart/cartTotalQuantity'])
    const decrementProductQuantity = (product) => store.dispatch('shoppingCart/decrementProductQuantity', product)
    const incrementProductQuantity = (product) => store.dispatch('shoppingCart/incrementProductQuantity', product)
    const removeProductFromCart = (product) => store.dispatch('shoppingCart/removeProductFromCart', product)
    const router = useRouter()
    const totalWithTaxes = computed(() => {
      const subtotal = parseFloat(Number(total.value).toFixed(2))
      const pst = parseFloat((Number(total.value) * 0.07).toFixed(2))
      const gst = parseFloat((Number(total.value) * 0.05).toFixed(2))
      return subtotal + pst + gst
    })
    const decrementQuantity = (product) => {
      decrementProductQuantity(product)
    }

    const incrementQuantity = (product) => {
      incrementProductQuantity(product)
    }

    const removeProduct = (product) => {
      removeProductFromCart(product.priceId)
      context.emit('cartPreviewShouldOpen')
    }

    const checkout = async () => {
      context.emit('cartPreviewShouldClose')
      router.push('/cart')
    }
    return {
      shoppingCart,
      total,
      totalQuantity,
      decrementQuantity,
      incrementQuantity,
      removeProduct,
      checkout,
      totalWithTaxes
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

    <style scoped>
    body{
        min-height: 100vh;
        vertical-align: middle;
        display: flex;
        font-family: sans-serif;
        font-size: 0.8rem;
        font-weight: bold;
    }
    .title{
        margin-bottom: 5vh;
    }
    .card{
        width: 100%;
        border-radius: 1rem;
        border: transparent;
        margin-bottom: 20px;
    }
    @media(max-width:767px){
        .card{
            margin: 3vh auto;
        }
    }
    .cart{
        background-color: #fff;
        border-bottom-left-radius: 1rem;
        border-top-left-radius: 1rem;
        margin-top: 0px;
    }
    @media(max-width:767px){
        .cart{
            border-bottom-left-radius: unset;
            border-top-right-radius: 1rem;
        }
    }
    .summary{
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
        padding: 10px;
    }
    @media(max-width:767px){
        .summary{
        border-top-right-radius: unset;
        border-bottom-left-radius: 1rem;
        }
    }
    .summary .col-2{
        padding: 0;
    }

    .iq-top-navbar .iq-sub-dropdown .iq-card-body div {
        border-radius: 0;
    }
    .summary .col-10
    {
        padding: 0;
    }.row{
        margin: 0 10px;
    }
    .title b{
        font-size: 1.5rem;
    }
    .main{
        margin: 0;
        padding: 2vh 0;
        width: 100%;
    }
    .col-2, .col{
        padding: 0 1vh;
    }
    a{
        padding: 0 1vh;
    }
    .close{
        margin-left: auto;
        font-size: 0.7rem;
        margin-top: 5px;
        cursor: pointer;
    }
    img{
        width: 3.5rem;
    }
    .back-to-shop{
        margin-top: 4.5rem;
    }
    h5{
        margin-top: 4vh;
    }
    hr{
        margin-top: 1.25rem;
    }
    form{
        padding: 2vh 0;
    }
    select{
        border: 1px solid rgba(0, 0, 0, 0.137);
        padding: 1.5vh 1vh;
        margin-bottom: 4vh;
        outline: none;
        width: 100%;
        background-color: rgb(247, 247, 247);
    }
    input{
        border: 1px solid rgba(0, 0, 0, 0.137);
        padding: 1vh;
        margin-bottom: 4vh;
        outline: none;
        width: 100%;
        background-color: rgb(247, 247, 247);
    }
    input:focus::-webkit-input-placeholder
    {
          color:transparent;
    }
    .btn{
        color: white;
        width: 100%;
        font-size: 0.7rem;
        padding: 1vh;
        border-radius: 0;
    }
    .btn:focus{
        box-shadow: none;
        outline: none;
        box-shadow: none;
        color: white;
        -webkit-box-shadow: none;
        -webkit-user-select: none;
        transition: none;
    }
    .btn:hover{
        color: white;
    }
    a{
        color: black;
    }
    a:hover{
        color: black;
        text-decoration: none;
    }
     #code{
        background-repeat: no-repeat;
        background-position-x: 95%;
        background-position-y: center;
    }

    input[type="checkbox"] {
accent-color: var(--accent-color);
}
    </style>
